import { INSERT_HORIZONTAL_RULE_COMMAND } from '@lexical/extension';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { Minus, Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useFeatureEnabled } from '../../core/context/FeaturesContext';
import { ToolbarButton, ToolbarGroup } from '../../ui/ToolbarButton';
import { ToolbarMenu } from '../../ui/ToolbarMenu';
import { ImageControl } from '../images/ImageControl';
import { LinkControl } from '../links/LinkControl';
import { TableSizePicker } from '../tables/TableSizePicker';
import { SpecialCharactersControl } from './SpecialCharactersControl';
import type { ToolbarState } from './useToolbarState';

/** Link and image, plus the "⋮" popup with table, special characters and horizontal line; each only if its feature is on. */
export const InsertGroup = ({ state, disabled }: { state: ToolbarState; disabled: boolean }) => {
  const [editor] = useLexicalComposerContext();
  const { t } = useTranslation('common');
  const links = useFeatureEnabled('links');
  const images = useFeatureEnabled('images');
  const tables = useFeatureEnabled('tables');
  const horizontalRule = useFeatureEnabled('horizontalRule');

  return (
    <ToolbarGroup>
      {links && <LinkControl isLink={state.isLink} disabled={disabled} />}
      {images && <ImageControl disabled={disabled} />}
      <ToolbarMenu icon={Plus} caret="more" layout="row" label={t('editor.toolbar.more-rich')} disabled={disabled}>
        {(close) => (
          <>
            {tables && <TableSizePicker disabled={disabled} onInserted={close} />}
            <SpecialCharactersControl disabled={disabled} />
            {horizontalRule && (
              <ToolbarButton
                icon={Minus}
                label={t('editor.toolbar.horizontal-rule')}
                onClick={() => {
                  editor.dispatchCommand(INSERT_HORIZONTAL_RULE_COMMAND, undefined);
                  close();
                }}
              />
            )}
          </>
        )}
      </ToolbarMenu>
    </ToolbarGroup>
  );
};
